import './Experience.css'

import { Canvas, useFrame, useThree, extend } from '@react-three/fiber'
import { MeshReflectorMaterial, OrbitControls, useProgress, Bounds, PerspectiveCamera, Float, ScrollControls, Scroll } from '@react-three/drei'
import { useRef, useState, useMemo, useEffect, memo } from 'react'
import { Perf } from 'r3f-perf'
import { Model } from './Model'
import { Suspense } from 'react'
import { EffectComposer, Scanline, ChromaticAberration, Noise, Bloom, DotScreen, DepthOfField } from '@react-three/postprocessing' // EffectComposer
import * as THREE from 'three'
import { useSpring, a } from '@react-spring/three'

import Fragments from './Fragments'
import Floor from './Floor'
import Particles from './Particles.js'

function Experience(props)
{

    console.log("experience rendered")
    const sphere = useRef(null)
    const cube = useRef(null)

    const [modelLoaded, setModelLoaded] = useState(false)
    const [labelPositions, setLabelPositions] = useState([])

    const orderedShards = [31, 19, 4, 45, 10, 34, 8, 30, 36, 46, 27, 21, 22, 29]

    return <>

        <Canvas
            // eventSource={[props.outerDivRef]}
            // offset={'client'}
            // frameloop="demand"
            dpr={1}
            className={modelLoaded ? "experience active" : "experience"}
            style={{ position: 'relative', height: '100vh', zIndex: `0` }}
            linear
            gl={{ antialias: true, toneMapping: THREE.NoToneMapping }}
        >

            {/* debug if /#debug in URL */}
            {
                window.location.href.indexOf("#debug") > -1 && <Perf />
            }

            <OrbitControls
                makeDefault

                minAzimuthAngle={Infinity}
                maxAzimuthAngle={Infinity}
                minPolarAngle={0}
                maxPolarAngle={Math.PI * 0.7}

                maxDistance={6}
                minDistance={6}

                enablePan={false}
                enableZoom={false}
            />

            <ambientLight intensity={0.4} />

            <PerspectiveCamera makeDefault position={[0, 0, 4.6]}>
                {/* <directionalLight position={[1, 2, 3]} intensity={1} /> */}
                <spotLight

                    intensity={1}
                    angle={Math.PI / 8}
                    decay={-10}
                    penumbra={.4}

                />
            </PerspectiveCamera>

            <Suspense fallback={null}>
                <Float
                    speed={1}
                    rotationIntensity={.5}
                    floatIntensity={0}
                >
                    <Model
                        setModelLoaded={setModelLoaded}

                        delay={props.animateInDelay}
                        scale={1.05}
                        selectedShardsScale={2}
                        speed={0.2}
                        selectedShards={orderedShards.slice(0, props.shardsCount)}
                        setArticleOpen={props.setArticleOpen}
                        setCurrentArticleIndex={props.setCurrentArticleIndex}
                    />

                    <Fragments
                        delay={props.animateInDelay}
                        count={160}
                    />
                    {/* <Particles
                        delay={props.animateInDelay}
                        count={20000}
                        particleSize={.3}
                    /> */}
                </Float>
            </Suspense>

            <Effects />

        </Canvas>
    </>
}

const Effects = memo(() =>
{
    return (
        <EffectComposer>
            {/* <Noise opacity={.3} /> */}
            <ChromaticAberration
                offset={[0.0005, 0.0005]} // color offset
                opacity={0.1}
            />
            <DepthOfField focusDistance={0.003} focalLength={0.003} bokehScale={5} />
            {/* <Scanline
                    opacity={.05}
                    density={1} // scanline density
                    scrollSpeed={0.02}
                /> */}
            {/* <Bloom luminanceThreshold={1} intensity={1} levels={5} mipmapBlur /> */}

        </EffectComposer>
    )
})

export default Experience